module.exports = __webpack_public_path__ + "img/image-7-2.890fe765.png";